import asyncComponent from '@/components/asyncComponent/asyncComponent';

const sysRoute = [
  {
    path: '/auth/sys/menuList',
    component: asyncComponent(() => import(/* webpackChunkName: "sys" */ '@/pages/sys/menuList')),
    meta: {
      title: '新菜单管理 | 犇犇汽配联盟后台'
    }
  },
  {
    path: '/auth/sys/roleList',
    component: asyncComponent(() => import(/* webpackChunkName: "sys" */ '@/pages/sys/roleList')),
    meta: {
      title: '新角色管理 | 犇犇汽配联盟后台'
    }
  },
  {
    path: '/auth/sys/userList',
    component: asyncComponent(() => import(/* webpackChunkName: "sys" */ '@/pages/sys/userList')),
    meta: {
      title: '新用户管理 | 犇犇汽配联盟后台'
    }
  },
  {
    path: '/auth/sys/sysConf',
    component: asyncComponent(() => import(/* webpackChunkName: "sys" */ '@/pages/sys/sysConf')),
    meta: {
      title: '系统参数配置 | 犇犇汽配联盟后台'
    }
  },
  {
    path: '/auth/sys/sysDict',
    component: asyncComponent(() => import(/* webpackChunkName: "sys" */ '@/pages/sys/sysDict')),
    meta: {
      title: '数据字典管理 | 犇犇汽配联盟后台'
    }
  }
];

export default sysRoute;